export default __webpack_public_path__ + "static/media/empty_credit_card.6819c05d.svg";